// extracted by mini-css-extract-plugin
export default {"container":"integrations_container__BAts7","cardsContainer":"integrations_cardsContainer__F2PC3"};